/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetApplicationDocument404Response,
  GetDocument422Response,
} from '../models/index'
import {
  GetApplicationDocument404ResponseFromJSON,
  GetApplicationDocument404ResponseToJSON,
  GetDocument422ResponseFromJSON,
  GetDocument422ResponseToJSON,
} from '../models/index'

export interface GetDocumentRequest {
  slug: string
  type?: GetDocumentTypeEnum
}

/**
 * DocumentApi - interface
 *
 * @export
 * @interface DocumentApiInterface
 */
export interface DocumentApiInterface {
  /**
   * Файл документа со страницы «Документы» по slug элемента. Отдаётся бинарное содержимое: Content-Type по фактическому файлу, Content-Disposition — inline или attachment.
   * @summary Файл документа по slug
   * @param {string} slug Slug документа на странице «Документы»
   * @param {'inline' | 'attachment'} [type] Тип Content-Disposition (по умолчанию inline)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApiInterface
   */
  getDocumentRaw(
    requestParameters: GetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Файл документа со страницы «Документы» по slug элемента. Отдаётся бинарное содержимое: Content-Type по фактическому файлу, Content-Disposition — inline или attachment.
   * Файл документа по slug
   */
  getDocument(
    requestParameters: GetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>
}

/**
 *
 */
export class DocumentApi
  extends runtime.BaseAPI
  implements DocumentApiInterface
{
  /**
   * Файл документа со страницы «Документы» по slug элемента. Отдаётся бинарное содержимое: Content-Type по фактическому файлу, Content-Disposition — inline или attachment.
   * Файл документа по slug
   */
  async getDocumentRaw(
    requestParameters: GetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['slug'] == null) {
      throw new runtime.RequiredError(
        'slug',
        'Required parameter "slug" was null or undefined when calling getDocument().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/documents/{slug}`.replace(
          `{${'slug'}}`,
          encodeURIComponent(String(requestParameters['slug']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Файл документа со страницы «Документы» по slug элемента. Отдаётся бинарное содержимое: Content-Type по фактическому файлу, Content-Disposition — inline или attachment.
   * Файл документа по slug
   */
  async getDocument(
    requestParameters: GetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getDocumentRaw(requestParameters, initOverrides)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetDocumentTypeEnum {
  Inline = 'inline',
  Attachment = 'attachment',
}
